import React from "react"
import Head from "next/head"

import { Container, Card } from "react-bootstrap"

function ComplaintsProcedure() {
    const url = "https://webbjenkins.co.uk/complaints-procedure/"
    const title = "Complaints Procedure - Webb Jenkins"
    const description =
        "Read more about our complaints procedure to understand how we handle the rare cases where our clients are not satisfied with our service."
    const imgUrl =
        "https://webb-jenkins-static-164679926.imgix.net/socials/webbjenkins-complaints-social.jpg"
    const imgWidth = 1200
    const imgHeight = 630
    const imgAlt = "Webb Jenkins logo with complaints procedure caption"

    return (
        <>
            <Head>
                <link rel="canonical" href={url} />
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta property="fb:app_id" content="362437448786240" />
                <meta property="og:title" content={title} />
                <meta property="og:image:url" content={imgUrl} />
                <meta property="og:image:width" content={imgWidth} />
                <meta property="og:image:height" content={imgHeight} />
                <meta property="og:image:alt" content={imgAlt} />
                <meta property="og:description" content={description} />
                <meta property="og:url" content={url} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_GB" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image:src" content={imgUrl} />
                <meta name="twitter:site" content="@WebbJenkinsIOW" />
            </Head>
            <Container fluid="md" as={Card} className="mt-5 mb-4">
                <Card.Body>
                    <Card.Title>
                        <h1 className="text-center">Complaints procedure</h1>
                    </Card.Title>
                </Card.Body>
            </Container>
            <Container fluid="md" as={Card}>
                <Card.Body>
                    <p>Last updated: February 11, 2022</p>
                    <h2>In-house complaints procedure</h2>
                    <p>
                        We are committed to providing a professional service to
                        all our clients and customers. When something goes
                        wrong, we need you to tell us about it. This will help
                        us to improve our standards.
                    </p>
                    <p>
                        If you have a complaint, please put it in writing,
                        including as much detail as possible. We will then
                        respond in line with the timeframes set out below (if
                        you feel we have not sought to address your complaints
                        within eight weeks, you may be able to refer your
                        complaint to the Property Ombudsman to consider without
                        our final viewpoint on the matter).
                    </p>
                    <h2>What will happen next?</h2>
                    <ul>
                        <li>
                            <p>
                                We will send you a letter acknowledging receipt
                                of your complaint within three working days of
                                receiving it, enclosing a copy of this
                                procedure.
                            </p>
                        </li>
                        <li>
                            <p>
                                We will then investigate your complaint. This
                                will normally be dealt with by the office
                                manager who will review your file and speak to
                                the member of staff who dealt with you. A formal
                                written outcome of our investigation will be
                                sent to you within 15 working days of sending
                                the acknowledgement letter.
                            </p>
                        </li>
                        <li>
                            <p>
                                If, at this stage, you are still not satisfied,
                                you should contact us again and we will arrange
                                for a separate review to take place by a senior
                                member of staff.
                            </p>
                        </li>
                        <li>
                            <p>
                                We will write to you within 15 working days of
                                receiving your request for a review, confirming
                                our final viewpoint on the matter.
                            </p>
                        </li>
                    </ul>
                    <p>
                        If you remain dissatisfied, you can then contact The
                        Property Ombudsman to request an independent review:
                    </p>

                    <p className="mb-0 text-center">
                        <b>The Property Ombudsman Ltd</b>
                    </p>
                    <p className="mb-0 text-center">
                        <b>Milford House</b>
                    </p>
                    <p className="mb-0 text-center">
                        <b>43-45 Milford Street</b>
                    </p>
                    <p className="mb-0 text-center">
                        <b>Salisbury</b>
                    </p>
                    <p className="mb-0 text-center">
                        <b>Wiltshire</b>
                    </p>
                    <p className="text-center">
                        <b>SP1 2BP</b>
                    </p>
                    <p className="mb-0 text-center">
                        <b>01722 333 306</b>
                    </p>
                    <p className="text-center">
                        <b>www.tpos.co.uk</b>
                    </p>
                    <p>
                        Please note the following: You will need to submit your
                        complaint to The Property Ombudsman within 12 months of
                        receiving our final viewpoint letter, including any
                        evidence to support your case. The Property Ombudsman
                        requires that all complaints are addressed through this
                        in-house complaints procedure, before being submitted
                        for an independent review.
                    </p>
                    <p className="mt-5">
                        If you have any questions regarding this procedure,
                        please contact a member of staff on{" "}
                        <a href="tel:01983 856111" role="button">
                            <b>01983 856111</b>
                        </a>{" "}
                        or via email to{" "}
                        <b>propertyservices@webbjenkins.co.uk</b>.
                    </p>
                </Card.Body>
            </Container>
        </>
    )
}

export default ComplaintsProcedure
